<template>
  <div class="bottom-bar">
    <b-pagination
      v-show="!showOnlySelected"
      ref="pa"
      v-model="current"
      class="c-pagination"
      pills
      align="center"
      :total-rows="totalCount"
      :per-page="pageSize"
      @change="paginationChange"
    >
      <slot />
    </b-pagination>
  </div>
</template>

<script>

import {createNamespacedHelpers} from "vuex";

const {
  mapActions,
  mapGetters,
} = createNamespacedHelpers('fileBrowserProductSelector')

export default {
  name: "PaginationComponent",
  data: () => ({
    current: 1
  }),
  computed: {
    ...mapGetters([
      'pageSize',
      'totalCount',
      'currentPage',
      'showOnlySelected',
    ])
  },
  watch: {
    currentPage(v) {
      if (v !== this.current) {
        this.current = v;
      }
    },
  },
  created() {
    this.current = this.currentPage;
  },
  methods: {
    ...mapActions([
      'setCurrentPage',
      'fetchCurrentBrowserData'
    ]),
    paginationChange(page) {
      this.setCurrentPage(page);
      this.fetchCurrentBrowserData();
    }
  }
}
</script>

<style scoped lang="scss">
.c-pagination {
  width: fit-content;
  margin: .75rem auto;

  ::v-deep .page-item {
    .page-link {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      color: #727272;
      border: none;
    }

    .page-link:hover {
      background-color: #95d9cc;
    }

    .page-link:focus {
      box-shadow: unset;
    }
  }

  ::v-deep .page-item.active {
    .page-link {
      background-color: #007964;
      color: white;
    }
  }
}
</style>
